import { IRequestOptions, TResponseResult } from 'models/api.model'
import { IWeb2WaveUserRaw } from 'models/web2waveApi.model'

import { ApiService } from 'services/api.service'

import { RequestMethod } from 'root-constants'

const WEB2WAVE_API_URL = 'https://w2w-user.gismart.xyz'

export class Web2WaveApi {
  private readonly baseUrlV1 = `${WEB2WAVE_API_URL}/web2wave/v1`
  private api: ApiService

  constructor(api: ApiService) {
    this.api = api
  }

  getUser({
    appName,
    firebaseToken,
  }: {
    appName: string
    firebaseToken: string
  }): Promise<TResponseResult<IWeb2WaveUserRaw>> {
    const options: IRequestOptions = {
      method: RequestMethod.GET,
      params: {
        app_name: appName,
        firebase_token: firebaseToken,
      },
    }

    return this.api.makeThirdPartyRequest<IWeb2WaveUserRaw>(
      `${this.baseUrlV1}/user`,
      options,
    )
  }
}
